import React from "react";
import { Link } from "react-router-dom";
import Footer from "../components/footer/Footer";
import ThankYouHero from "../components/slider/ThankYouHero";
import Social from "../components/Social";
import useDocumentTitle from "../components/useDocumentTitle";

const ThankYou = () => {
  useDocumentTitle("Thanks! || edcodehead");
  return (
    <>
      <ThankYouHero />
      {/* Secondary section removed per request */}
      <footer className="footer white">
        <div className="container">
          <Footer />
        </div>
      </footer>
    </>
  );
};

export default ThankYou;


